"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var companyApi = _interopRequireWildcard(require("@/api/merchantStatementCompanyApi"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _GenerateDialog = _interopRequireDefault(require("./components/GenerateDialog.vue"));
var _ReconciliationRemarkDialog = _interopRequireDefault(require("./components/ReconciliationRemarkDialog.vue"));
var _ConfirmStatementDialog = _interopRequireDefault(require("./components/ConfirmStatementDialog.vue"));
var _FinancialRemarkDialog = _interopRequireDefault(require("./components/FinancialRemarkDialog.vue"));
var _DownloadRecordDialog = _interopRequireDefault(require("./components/DownloadRecordDialog.vue"));
var _PaymentDetailDialog = _interopRequireDefault(require("./components/PaymentDetailDialog.vue"));
var _StatementDetailDialog = _interopRequireDefault(require("./components/StatementDetailDialog.vue"));
var _StatementOrderDialog = _interopRequireDefault(require("./components/StatementOrderDialog.vue"));
var _UnreconciledDialog = _interopRequireDefault(require("./components/UnreconciledDialog.vue"));
var _StatementPaymentDialog = _interopRequireDefault(require("./components/StatementPaymentDialog.vue"));
var _RejectStatementDialog = _interopRequireDefault(require("./components/RejectStatementDialog.vue"));
var _UpdateStatementDialog = _interopRequireDefault(require("./components/UpdateStatementDialog.vue"));
var _StatementListExportTaskDialog = _interopRequireDefault(require("./components/StatementListExportTaskDialog.vue"));
var _StatementListExportRecordDialog = _interopRequireDefault(require("./components/StatementListExportRecordDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var STATEMENT_EXPORT_FIELDS = ['statementNo', 'merchantId', 'merchantType', 'status', 'reconciliationStatus', 'paymentStatus', 'companyId', 'orderNo', 'creatorId', 'startTime', 'endTime', 'paymentTimeStart', 'paymentTimeEnd', 'hasLoss'];
var _default = exports.default = {
  name: 'MerchantStatementList',
  components: {
    GenerateDialog: _GenerateDialog.default,
    ReconciliationRemarkDialog: _ReconciliationRemarkDialog.default,
    ConfirmStatementDialog: _ConfirmStatementDialog.default,
    FinancialRemarkDialog: _FinancialRemarkDialog.default,
    PaymentDetailDialog: _PaymentDetailDialog.default,
    DownloadRecordDialog: _DownloadRecordDialog.default,
    StatementDetailDialog: _StatementDetailDialog.default,
    StatementOrderDialog: _StatementOrderDialog.default,
    UnreconciledDialog: _UnreconciledDialog.default,
    StatementPaymentDialog: _StatementPaymentDialog.default,
    RejectStatementDialog: _RejectStatementDialog.default,
    UpdateStatementDialog: _UpdateStatementDialog.default,
    StatementListExportTaskDialog: _StatementListExportTaskDialog.default,
    StatementListExportRecordDialog: _StatementListExportRecordDialog.default
  },
  data: function data() {
    return {
      listPram: {
        page: 1,
        limit: 20,
        statementNo: '',
        orderNo: '',
        merchantType: '',
        merchantId: '',
        companyId: '',
        creatorId: '',
        creatorName: '',
        hasLoss: '',
        status: '',
        paymentStatus: '',
        reconciliationStatus: ''
      },
      paymentTimeRange: [],
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      summaryLoading: false,
      statementSummary: {
        orderAmount: 0,
        settlementAmount: 0,
        actualSettlementAmount: 0,
        settledPriceDifference: 0
      },
      exportLoading: false,
      merchantOptions: [],
      merchantLoading: false,
      companyOptions: [],
      companyLoading: false,
      creatorOptions: [],
      creatorLoading: false,
      statementPageActive: true,
      remarkPopover: {
        visible: false,
        title: '',
        content: ''
      }
    };
  },
  created: function created() {
    this.loadMerchants();
    this.loadCompanyOptions();
    this.debouncedCreateStatementExport = (0, _validate.Debounce)(this.createStatementExport, 300);
  },
  mounted: function mounted() {
    this.statementPageActive = true;
    this.getList();
    this.getSummary();
  },
  activated: function activated() {
    this.statementPageActive = true;
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.statementPageActive = false;
    this.cleanupStatementListExport();
    next();
  },
  beforeDestroy: function beforeDestroy() {
    this.statementPageActive = false;
    this.cleanupStatementListExport();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.getList();
      this.getSummary();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = this.buildStatementQueryParams();
      statementApi.statementListApi(params).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    getSummary: function getSummary() {
      var _this2 = this;
      this.summaryLoading = true;
      var params = this.buildStatementQueryParams(false);
      statementApi.statementSummaryApi(params).then(function (data) {
        _this2.statementSummary = {
          orderAmount: data && data.orderAmount !== undefined ? data.orderAmount : 0,
          settlementAmount: data && data.settlementAmount !== undefined ? data.settlementAmount : 0,
          actualSettlementAmount: data && data.actualSettlementAmount !== undefined ? data.actualSettlementAmount : 0,
          settledPriceDifference: data && data.settledPriceDifference !== undefined ? data.settledPriceDifference : 0
        };
      }).catch(function () {
        _this2.statementSummary = {
          orderAmount: 0,
          settlementAmount: 0,
          actualSettlementAmount: 0,
          settledPriceDifference: 0
        };
      }).finally(function () {
        _this2.summaryLoading = false;
      });
    },
    buildStatementQueryParams: function buildStatementQueryParams() {
      var includePagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var params = _objectSpread({}, this.listPram);
      if (!includePagination) {
        delete params.page;
        delete params.limit;
      }
      if (Array.isArray(this.paymentTimeRange) && this.paymentTimeRange.length === 2) {
        params.paymentTimeStart = this.paymentTimeRange[0];
        params.paymentTimeEnd = this.paymentTimeRange[1];
      }
      Object.keys(params).forEach(function (key) {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      return params;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.listPram.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.getList();
    },
    handleGenerate: function handleGenerate() {
      this.$refs.generateDialog.open();
    },
    goUnreconciled: function goUnreconciled() {
      this.$refs.unreconciledDialog.open();
    },
    handleExport: function handleExport() {
      if (this.exportLoading) return;
      this.exportLoading = true;
      this.debouncedCreateStatementExport();
    },
    createStatementExport: function () {
      var _createStatementExport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!this.statementPageActive || this._isBeingDestroyed || this._isDestroyed)) {
                _context.n = 1;
                break;
              }
              this.exportLoading = false;
              return _context.a(2);
            case 1:
              if (this.$refs.statementListExportTaskDialog) {
                _context.n = 2;
                break;
              }
              this.exportLoading = false;
              return _context.a(2);
            case 2:
              _context.p = 2;
              params = this.buildStatementExportParams();
              _context.n = 3;
              return this.$refs.statementListExportTaskDialog.create(params);
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
            case 5:
              _context.p = 5;
              this.exportLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function createStatementExport() {
        return _createStatementExport.apply(this, arguments);
      }
      return createStatementExport;
    }(),
    buildStatementExportParams: function buildStatementExportParams() {
      var currentFilters = this.buildStatementQueryParams(false);
      return STATEMENT_EXPORT_FIELDS.reduce(function (params, field) {
        var value = currentFilters[field];
        if (value !== '' && value !== null && value !== undefined) {
          params[field] = value;
        }
        return params;
      }, {});
    },
    openStatementListExportRecords: function openStatementListExportRecords() {
      this.$refs.statementListExportRecordDialog.open();
    },
    cleanupStatementListExport: function cleanupStatementListExport() {
      var taskDialog = this.$refs.statementListExportTaskDialog;
      if (taskDialog) taskDialog.stopPolling();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: 20,
        statementNo: '',
        orderNo: '',
        merchantType: '',
        merchantId: '',
        companyId: '',
        creatorId: '',
        creatorName: '',
        hasLoss: '',
        status: '',
        paymentStatus: '',
        reconciliationStatus: ''
      };
      this.paymentTimeRange = [];
      this.merchantOptions = [];
      this.creatorOptions = [];
      this.handerSearch();
    },
    handleDetail: function handleDetail(row) {
      this.$refs.statementDetailDialog.open(row);
    },
    handleStatementDetail: function handleStatementDetail(row) {
      this.$refs.statementOrderDialog.open(row, {
        statementNo: row.statementNo,
        merchantName: row.merchantName,
        merchantType: row.merchantType,
        periodStart: row.periodStart,
        periodEnd: row.periodEnd,
        periodDesc: row.periodDesc,
        merchantId: row.merchantId,
        reconciliationStatus: row.reconciliationStatus
      });
    },
    handleDownload: function handleDownload(row) {
      this.$refs.downloadDialog.open(row.id, row.statementNo, row);
    },
    handlePayment: function handlePayment(row) {
      this.$refs.statementPaymentDialog.open(row);
    },
    handleConfirm: function handleConfirm(row) {
      this.$refs.confirmStatementDialog.open(row);
    },
    handleEdit: function handleEdit(row) {
      this.$refs.confirmStatementDialog.openEdit(row);
    },
    handleReject: function handleReject(row) {
      this.$refs.rejectStatementDialog.open(row);
    },
    handleUpdate: function handleUpdate(row) {
      this.$refs.updateStatementDialog.open(row);
    },
    handleRemark: function handleRemark(row) {
      this.$refs.reconciliationRemarkDialog.open(row);
    },
    handleFinancialRemark: function handleFinancialRemark(row) {
      this.$refs.financialRemarkDialog.open(row);
    },
    handlePaymentDetail: function handlePaymentDetail(row) {
      this.$refs.paymentDetailDialog.open(row);
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm("\u662F\u5426\u786E\u8BA4\u5220\u9664\u3010".concat(row.statementNo, "\u3011\u5BF9\u8D26\u5355\uFF1F"), '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        statementApi.statementDeleteApi(row.id).then(function () {
          _this3.$message.success('删除成功');
          _this3.getList();
        });
      }).catch(function () {});
    },
    handleRegenerate: function handleRegenerate(row) {
      var _this4 = this;
      this.$confirm('确定重新生成该对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        statementApi.statementRegenerateApi(row.id).then(function () {
          _this4.$message.success('重新生成任务已提交');
          _this4.getList();
        });
      }).catch(function () {});
    },
    formatAmount: function formatAmount(val) {
      return val ? Number(val).toFixed(2) : '0.00';
    },
    formatActualSettlementAmount: function formatActualSettlementAmount(row) {
      var actualAmount = Number(row.actualAmount || 0);
      var actualSettlementFreightAmount = Number(row.actualSettlementFreightAmount || 0);
      var actualSettlementPackingFeeAmount = Number(row.actualSettlementPackingFeeAmount || 0);
      return this.formatAmount(actualAmount + actualSettlementFreightAmount + actualSettlementPackingFeeAmount);
    },
    hasAmount: function hasAmount(val) {
      if (val === '' || val === null || val === undefined) return false;
      var amount = Number(val);
      return !isNaN(amount) && amount !== 0;
    },
    statusText: function statusText(val) {
      var m = {
        0: '已生成',
        1: '生成中',
        2: '生成失败'
      };
      return m[val] || '-';
    },
    statusTagType: function statusTagType(val) {
      var m = {
        0: 'success',
        1: 'primary',
        2: 'danger'
      };
      return m[val] || 'info';
    },
    merchantTypeText: function merchantTypeText(val) {
      var m = {
        1: '卡券供应商',
        2: '实物供应商',
        3: '家政供应商',
        4: '核销供应商'
      };
      return m[val] || '-';
    },
    reconciliationStatusText: function reconciliationStatusText(val) {
      var m = {
        0: '未核对',
        1: '已核对',
        2: '已驳回'
      };
      return m[val] || val || '-';
    },
    reconciliationStatusTagType: function reconciliationStatusTagType(val) {
      var m = {
        0: 'info',
        1: 'success',
        2: 'danger'
      };
      return m[val] || 'info';
    },
    formatRejectReason: function formatRejectReason(val) {
      if (!val) return '-';
      var text = String(val);
      return text.length > 10 ? "".concat(text.slice(0, 10), "...") : text;
    },
    paymentStatusTagType: function paymentStatusTagType(val) {
      var m = {
        0: 'info',
        1: 'danger',
        2: 'success'
      };
      return m[val] || 'info';
    },
    paymentStatusText: function paymentStatusText(val) {
      var m = {
        0: '未打款',
        1: '部分打款',
        2: '已打款'
      };
      return m[val] || '-';
    },
    loadMerchants: function loadMerchants(keyword) {
      var _this5 = this;
      if (!keyword) keyword = '';
      this.merchantLoading = true;
      statementApi.getMerchantOptionsApi(keyword, this.listPram.merchantType || null).then(function (res) {
        _this5.merchantOptions = res || [];
      }).catch(function () {
        _this5.merchantOptions = [];
      }).finally(function () {
        _this5.merchantLoading = false;
      });
    },
    handleMerchantSearch: function handleMerchantSearch(keyword) {
      this.loadMerchants(keyword);
    },
    onMerchantTypeChange: function onMerchantTypeChange() {
      this.listPram.merchantId = '';
      this.merchantOptions = [];
      this.loadMerchants();
    },
    loadCompanyOptions: function loadCompanyOptions() {
      var _this6 = this;
      this.companyLoading = true;
      companyApi.getCompanyList({
        page: 1,
        limit: 1000
      }).then(function (data) {
        _this6.companyOptions = data && data.list || [];
      }).catch(function () {
        _this6.companyOptions = [];
      }).finally(function () {
        _this6.companyLoading = false;
      });
    },
    handleCreatorSearch: function handleCreatorSearch(query) {
      var _this7 = this;
      this.creatorLoading = true;
      statementApi.getCreatorListApi(query || '').then(function (res) {
        _this7.creatorOptions = res || [];
      }).catch(function () {
        _this7.creatorOptions = [];
      }).finally(function () {
        _this7.creatorLoading = false;
      });
    },
    handleCreatorFocus: function handleCreatorFocus() {
      if (!this.creatorOptions.length) {
        this.handleCreatorSearch('');
      }
    },
    showRemarkPopover: function showRemarkPopover(event, content, title) {
      this.remarkPopover.title = title;
      this.remarkPopover.content = content;
      this.remarkPopover.visible = true;
    }
  }
};